import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@app/core/okta-auth.guard';
import { FinanceDashboardComponent } from './finance-dashboard/finance-dashboard.component';
import { RechargeRecoveryComponent } from './recharge-recovery/recharge-recovery.component';
import { FinanceDetailsComponent } from './finance-details/finance-details.component';
import { FinanceProjectHistoryComponent } from './finance-details/project-history/finance-project-history.component';
import { FinanceEditProjectComponent } from './finance-details/edit-project/finance-edit-project.component';
import { FinanceProjectsComponent } from './finance-details/finance-projects/finance-projects.component';
import { FinanceTierRatesComponent } from './finance-details/finance-tier-rates/finance-tier-rates.component';

const routes: Routes = [
  {
    path: 'finance',
    canActivate: [AuthGuard],
    children: [
      { path: '', component: FinanceDashboardComponent },
      { path: 'recharge-recovery', component: RechargeRecoveryComponent },
      { path: 'details', component: FinanceDetailsComponent },
      // Sibling-as-child URL: /finance/details/history/:resourceId renders
      // the standalone full-page history view (not inside FinanceDetails).
      { path: 'details/history/:resourceId', component: FinanceProjectHistoryComponent },
      // Edit Project full-page route — same pattern as History.
      { path: 'details/edit/:resourceId', component: FinanceEditProjectComponent },
      // Project Details listing reached via View Projects on Finance Details.
      { path: 'details/projects', component: FinanceProjectsComponent },
      // Tier Rates admin page reached via Tier Rates on Finance Details.
      { path: 'details/tier-rates', component: FinanceTierRatesComponent },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FinanceRoutingModule {}
